import { SVGProps, Ref, forwardRef } from 'react';

export const LabelFlameFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 1C3.75 1 1 6.5 1 12s2.75 11 11 11 11-5.5 11-11S20.25 1 12 1m-.81 4.386-.547-.333-.267.582C9.855 6.776 9.123 7.538 8.362 8.33q-.135.139-.269.28c-.846.888-1.686 1.863-1.976 3.411-.763 4.067 2.368 6.927 5.824 6.927 2.787 0 4.817-1.485 5.649-3.502.83-2.013.434-4.482-1.459-6.375l-.514-.515-.374.623a3.5 3.5 0 0 1-.608.704 3.8 3.8 0 0 1-.987.662c.044-.347.068-.766.03-1.224-.102-1.27-.675-2.826-2.488-3.934"
            fill="currentColor"
        />
    </svg>
));
LabelFlameFilledSize24Glyph.displayName = 'LabelFlameFilledSize24Glyph';
